function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M54.818,200.999c-15.23,0-28.171,5.327-38.832,15.987C5.33,227.642,0,240.583,0,255.813c0,15.223,5.33,28.172,15.99,38.83 c10.66,10.656,23.604,15.984,38.832,15.984c15.225,0,28.167-5.328,38.828-15.984c10.657-10.657,15.987-23.606,15.987-38.83 c0-15.23-5.33-28.171-15.99-38.828C82.989,206.329,70.046,200.999,54.818,200.999z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.821,54.817c-15.23,0-28.171,5.33-38.832,15.987C5.333,81.464,0.003,94.405,0.003,109.632 c0,15.229,5.327,28.171,15.986,38.831c10.66,10.657,23.604,15.985,38.832,15.985c15.225,0,28.167-5.329,38.828-15.985 c10.657-10.66,15.987-23.603,15.987-38.831c0-15.227-5.33-28.168-15.987-38.828C82.993,60.147,70.051,54.817,54.821,54.817z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.821,347.18c-15.23,0-28.175,5.325-38.832,15.981C5.333,373.824,0.003,386.767,0.003,401.989 c0,15.235,5.327,28.171,15.986,38.834c10.66,10.657,23.604,15.985,38.832,15.985c15.225,0,28.167-5.328,38.828-15.985 c10.657-10.663,15.987-23.599,15.987-38.834c0-15.223-5.33-28.172-15.987-38.828C82.993,352.505,70.051,347.18,54.821,347.18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M508.917,75.8c-1.813-1.803-3.949-2.708-6.427-2.708H155.313c-2.473,0-4.615,0.902-6.423,2.708 c-1.807,1.812-2.712,3.949-2.712,6.423v54.821c0,2.475,0.905,4.611,2.712,6.424c1.809,1.805,3.951,2.708,6.423,2.708H502.49 c2.478,0,4.616-0.9,6.427-2.708c1.81-1.812,2.71-3.949,2.71-6.424V82.224C511.626,79.75,510.723,77.609,508.917,75.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502.49,219.271H155.313c-2.473,0-4.615,0.9-6.423,2.712c-1.807,1.807-2.712,3.949-2.712,6.423v54.819 c0,2.472,0.905,4.613,2.712,6.421c1.809,1.813,3.951,2.714,6.423,2.714H502.49c2.478,0,4.616-0.9,6.427-2.714 c1.81-1.808,2.71-3.949,2.71-6.421v-54.819c0-2.474-0.903-4.62-2.71-6.423C507.103,220.175,504.967,219.271,502.49,219.271z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502.49,365.447H155.313c-2.473,0-4.615,0.903-6.423,2.714c-1.807,1.81-2.712,3.949-2.712,6.42V429.4 c0,2.478,0.905,4.616,2.712,6.427c1.809,1.807,3.951,2.707,6.423,2.707H502.49c2.478,0,4.616-0.9,6.427-2.707 c1.81-1.811,2.71-3.949,2.71-6.427v-54.819c0-2.471-0.903-4.617-2.71-6.42C507.103,366.357,504.967,365.447,502.49,365.447z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgUlist = function SvgUlist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 511.626 511.626",
    style: {
      enableBackground: "new 0 0 511.626 511.626"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ulist.fd935a81.svg";
export { ForwardRef as ReactComponent };